import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';
import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit';

export interface IPaginationWrapperProps {
  disabled?: boolean;
  onPrev?(): void;
  onNext?(): void;
  isFirstPage: boolean;
  isLastPage: boolean;
}

export const PaginationWrapper: React.FC<React.PropsWithChildren<IPaginationWrapperProps>> = ({
  children,
  disabled,
  isFirstPage,
  isLastPage,
  onNext,
  onPrev,
}) => (
  <div className={cn(styles['wrapper'], { [styles['disabled']]: disabled })}>
    {!isFirstPage && (
      <div className={styles['navigation']} onClick={onPrev} data-testid="pagination-prev">
        <IconChevronLeft16 color="primary_100" />
      </div>
    )}
    <div className={styles['items']}>{children}</div>
    {!isLastPage && (
      <div className={styles['navigation']} onClick={onNext} data-testid="pagination-next">
        <IconChevronRight16 color="primary_100" />
      </div>
    )}
  </div>
);

PaginationWrapper.displayName = 'PaginationWrapper';
